import { withRouter } from 'react-router-dom';
import React, { Component } from "react";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "../../View.jsx";
import ViewUtils from '../../ViewUtils';
import EnhancedToolbar from '../../widgets/Toolbar';
import EnhancedTable from '../../widgets/ResponsiveTable';
import AlertItem from "../../widgets/AlertItem";
import EditDialog from './OrganisationSDFEditDialog';
import withMenuPermission from "../../widgets/withMenuPermission";

const utils = new ViewUtils();
const toolbarRef = React.createRef();

const headCells = [
    { id: 'FirstName', numeric: false, disablePadding: true, label: 'First Name' },
    { id: 'Surname', numeric: false, disablePadding: true, label: 'Surname' },
    { id: 'Email', numeric: false, disablePadding: true, label: 'Email' },
    { id: 'StartDate', numeric: false, disablePadding: true, label: 'Start Date' },
    { id: 'EndDate', numeric: false, disablePadding: true, label: 'End Date' },
    { id: 'Status', numeric: false, disablePadding: true, label: 'SDF Status' },
    { id: 'Role', numeric: false, disablePadding: true, label: 'SDF Role' },
    { id: 'Document', numeric: false, disablePadding: true, label: 'Letter of Appointment', contentType: 'document' },
    { id: 'IDCopy', numeric: false, disablePadding: true, label: 'ID Copy', contentType: 'document' },
];

class OrganisationSDF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model: {
                Id: this.props.location.state.selection
            },
            editDialogOpen: false,
            selectedId: null,
            searchParameters: [{ Name: "OrganisationID", Value: this.props.location.state.organisationID }],
            clearSelectedRow: false
        }

        this.toolbarConfig = {
            items: [

                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },

                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'edit', label: '', tooltip: 'Change Role/Status', disabled: utils.isNull(this.state.selectedId), icon: 'EditIcon', visible: this.props.menuPermissionItem.Edit },
                    ]
                }
            ]
        }
    }


    handleToolbarButtonClick = (buttonId) => {
        if (buttonId === "edit") {
            this.setState({ editDialogOpen: true });
        }
        else if (buttonId === "close") {
            this.props.history.push({
                pathname: "/skillsOrganisation",
                state: { selection: this.props.location.state.organisationID }
            })
        }
        else {
            // this.setState({ editDialogOpen: true });
        }
    }

    handleFormValueChange(values) {

        let FinancialYearID = values.FinancialYear.Id;
        let newsearchParameters = [...this.state.searchParameters];
        let temp_element = { ...newsearchParameters[1] };
        temp_element.Value = FinancialYearID
        newsearchParameters[1] = temp_element;

        this.setState({
            searchParameters: JSON.parse(JSON.stringify(newsearchParameters))
        });
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedId: selection[0].Id, Message: "", clearSelectedRow: false });
        } else {
            this.setState({ selectedId: null, clearSelectedRow: false });
        }
        toolbarRef.current.setButtonDisabled("edit", selection === null || selection.length === 0);
    }

    postAddHandler(cancel, save, response) {
        if (save === true) {
            if (response.MessageType === "SUCCESS") {
                this.setState({
                    searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                    editDialogOpen: false,
                    selectedId: null,
                    Message: response.Message,
                    MessageStyle: "success",
                    clearSelectedRow: true
                });
                toolbarRef.current.setButtonDisabled("remove", true);
            }
            else {
                this.setState({
                    searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                    editDialogOpen: false,
                    selectedId: null,
                    Message: response.Message,
                    MessageStyle: response.MessageType
                });
            }
        }
        else if (cancel === true) {
            this.setState({
                editDialogOpen: false,
                selectedId: null,
                clearSelectedRow: true
            })
        }
    }

    closePrompt = () => {
        this.setState({ promptOpen: false, clearSelectedRow: true, selectedId: null })
    }

    onClearSelectedRow = () => {
        this.setState({ clearSelectedRow: false });
    }

    FileDownload = (rowid, headCell) => {
        console.clear();
        console.log(headCell.id);
        if (headCell.id === "Document") {
            
            utils.invokeUrl("api/sims/OrganisationSDF/downloaddocument?id=" + rowid, (response) => {

                var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
                var url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = response.Name;
                link.target = '_blank';
                link.click();
            }, (e) => {
                this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
            }
            );
        }
        else if (headCell.id === "IDCopy") {

            utils.invokeUrl("api/sims/OrganisationSDF/downloadIDCopy?id=" + rowid, (response) => {

                var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
                var url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = response.Name;
                link.target = '_blank';
                link.click();
            }, (e) => {
                this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
            }
            );
        }
    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="legend">
                    {"Organisation > SDF " + (this.props.location.state.organisationName !== null ? "> " + this.props.location.state.organisationName + (this.props.location.state.sdlnumber !== null ? " - " + this.props.location.state.sdlnumber : "") : "> Add")}
                </p>

                <AlertItem message={this.state.Message} alertStyle={this.state.MessageStyle} />

                <div className="searchResults">

                    <EnhancedToolbar highlight={false}
                        title="Organisation SDF"
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig}
                    />

                    <EnhancedTable
                        headCells={headCells}
                        onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        dataUrl="api/sims/OrganisationSDF/GetSearch"
                        searchParameters={this.state.searchParameters}
                        clearSelectedRow={this.state.clearSelectedRow} onClearSelectedRow={this.onClearSelectedRow}
                        onCellSelectionChange={(rowid, headCell) => { this.FileDownload(rowid, headCell) }}
                        paged={true} />
                </div>

                <EditDialog
                    open={this.state.editDialogOpen}
                    id={this.state.selectedId}
                    closeHandler={(cancel, save, response) => this.postAddHandler(cancel, save, response)}
                    viewRef={this}
                />

            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(OrganisationSDF));